import {Textarea, TextareaProps} from "@/components/ui/textarea";
import React, {RefObject, useCallback, useEffect, useRef} from "react";
import {cn} from "@/lib/utils";

export interface ResizableTextarea extends TextareaProps {
  areaRef?: RefObject<HTMLTextAreaElement | null>
  maxHeight?: number // Max height in pixels
}

export const ResizableTextarea = (props: ResizableTextarea) => {
  const {className, value, areaRef, maxHeight, onChange, onPaste, ...otherProps} = props;
  const newRef = useRef<HTMLTextAreaElement>(null);
  const ref = areaRef || newRef
  // eslint-disable-next-line react-hooks/preserve-manual-memoization
  const adjustHeight = useCallback(() => {
    if (ref.current) {
      ref.current.style.height = "auto"; // Reset height to recalculate
      const scrollHeight = ref.current.scrollHeight + 5;
      
      if (maxHeight && scrollHeight > maxHeight) {
        ref.current.style.height = `${maxHeight}px`;
        ref.current.style.overflowY = "auto";
      } else {
        ref.current.style.height = `${scrollHeight}px`; // Set to new height
        ref.current.style.overflowY = "hidden";
      }
    }
  }, [ref, maxHeight])
  useEffect(() => adjustHeight(), [adjustHeight, value])
  return <Textarea
    rows={1}
    {...otherProps}
    className={cn("focus-visible:ring-0 resize-none min-h-10 border rounded p-2", className)}
    ref={ref}
    value={value}
    onChange={e => {
      onChange?.(e)
      adjustHeight()
    }}
    onPaste={onPaste}
  />
}